
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store";

// Vendors
import moment from "moment";

// Models
import {AppPlayerMatchesRootListIndex} from "@/models/app/player/matches/root/list/index";
import {AppCommonMatchCategory} from "@/models/app/common/match-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppPlayerMatchesRootListFormCreateIndexVue from "@/views/app/player/matches/root/list/form/create.vue";
import AppPlayerMatchesRootListFormUpdateIndexVue from "@/views/app/player/matches/root/list/form/update.vue";
import AppPlayerMatchesRootListFormRemoveIndexVue from "@/views/app/player/matches/root/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  props: [
    "matchCategories",
  ],
  components: {
    ElRow,
    ElCol,
    AppPlayerMatchesRootListFormCreateIndexVue,
    AppPlayerMatchesRootListFormUpdateIndexVue,
    AppPlayerMatchesRootListFormRemoveIndexVue,
  },
})
export default class AppPlayerMatchesRootListIndexVue extends Vue {
  isLoading: boolean | null = false;

  formData: any = {
    filter: {
      user_id: store.getters.getAuthentication.id,
      match_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  moment: any = null;

  matchCategories: Array<AppCommonMatchCategory> = [];
  matches: Array<AppPlayerMatchesRootListIndex> = [];

  async getMatches(formData: any = null): Promise<void> {
    this.isLoading = true;

    if (formData) {
      this.formData = formData;
    }

    await getRequest({
      uri: `/common/matches`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.matches = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    await this.getMatches();
  }
}
